import { render } from "./PersonaModal.vue?vue&type=template&id=3228ba84&scoped=true"
import script from "./PersonaModal.vue?vue&type=script&lang=js"
export * from "./PersonaModal.vue?vue&type=script&lang=js"

import "./PersonaModal.vue?vue&type=style&index=0&id=3228ba84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3228ba84"]])

export default __exports__